module.exports = __webpack_public_path__ + "static/img/Brodie_Grundy_mobile.65e7d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brodie_Grundy_mobile.jpg
// module id = tOy+
// module chunks = 0